// Zentrale Konstanten der App. Magic Numbers gehoeren hier rein,
// nicht verstreut in Komponenten.

export const VIEWER_DEFAULTS = {
  defaultZoom: 30,        // PSV-Zoom 0-100
  defaultPitch: 0,        // Radiant
  transitionMs: 600,      // Pano-Wechsel-Dauer
  navbar: false as const, // PSV-Navbar deaktiviert (Sidebar ist die Navigation)
} as const;

export const UI = {
  mobileBreakpointPx: 900,
} as const;

// Phase-1-Demo-Pano (nur fuer den Bootstrap des Viewers; in Phase 2
// kommt die echte Tour-Definition aus src/data/tour.ts).
export const DEMO_PANO_URL =
  'https://photo-sphere-viewer-data.netlify.app/assets/sphere.jpg';
